
import wixWindow from 'wix-window';

$w.onReady(function () {

    if (wixWindow.multilingual.currentLanguage ===  'en') {
        $w('#columnStrip25').collapse();
		$w('#columnStrip12').collapse();
        $w('#columnStrip14').collapse();
        $w('#repeater1').collapse();
        
    } else {
        $w('#columnStrip25').show();
		$w('#columnStrip12').show();
        $w('#repeater1').show();
        $w('#columnStrip14').show();
    }
});